<div class="menu">
  <div class="logo">
    <div class="first"></div>
    <div class="second">
      <i class="pi pi-box"></i>
    </div>
    <div class="third"></div>
  </div>
</div>
<div class="login">
  <h1>{{ environment.softwareName }}</h1>
  <h3 class="text-center m-0">Scegli una nuova password</h3>
  <p-messages
    [(value)]="msgs"
    [enableService]="false"></p-messages>

  <div
    *ngIf="done"
    class="w-full">
    <p class="text-center m-0">Password aggiornata. Ora puoi accedere con la nuova password.</p>
    <div class="mx-auto w-3">
      <p-button
        styleClass="butt w-full"
        label="Vai al login"
        routerLink="/login"
        [rounded]="true" />
    </div>
  </div>

  <div
    *ngIf="!done && !hasToken"
    class="w-full">
    <p class="text-center m-0">
      Il link non è valido o è scaduto. Richiedine uno nuovo: il link è valido per 10 minuti e può
      essere usato una sola volta.
    </p>
    <div class="text-center">
      <a routerLink="/password-dimenticata">Richiedi un nuovo link</a>
    </div>
  </div>

  <form
    *ngIf="!done && hasToken"
    [formGroup]="frm"
    (ngSubmit)="submit()"
    class="w-full">
    <div class="flex flex-column gap-2 justify-content-center align-items-stretch">
      <div>
        <span class="p-float-label">
          <p-password
            inputId="newPassword"
            formControlName="newPassword"
            autocomplete="new-password"
            [toggleMask]="true"
            [feedback]="false"
            styleClass="w-full"
            [inputStyle]="{ width: '100%' }"></p-password>
          <label htmlFor="newPassword">Nuova password</label>
        </span>
        <small
          [class.p-error]="frm.get('newPassword')?.errors && frm.get('newPassword')?.dirty"
          >{{ passwordHint }}</small
        >
      </div>
      <div>
        <span class="p-float-label">
          <p-password
            inputId="confirmNewPassword"
            formControlName="confirmNewPassword"
            autocomplete="new-password"
            [toggleMask]="true"
            [feedback]="false"
            styleClass="w-full"
            [inputStyle]="{ width: '100%' }"></p-password>
          <label htmlFor="confirmNewPassword">Conferma password</label>
        </span>
        <small
          class="p-error"
          *ngIf="mismatch"
          >Le password non coincidono.</small
        >
      </div>
      <div class="mx-auto w-3">
        <p-button
          styleClass="butt w-full"
          type="submit"
          [disabled]="frm.invalid || mismatch"
          [loading]="loading"
          label="Salva"
          [rounded]="true" />
      </div>
    </div>
  </form>

  <div
    class="mx-auto"
    *ngIf="!done">
    <a routerLink="/login">Torna al login</a>
  </div>
</div>
